import { useState } from "react";

// Hover tooltip: an absolutely-positioned box inside a relative wrapper
// marked data-tip-root.
export function useTip() {
  const [tip, setTip] = useState(null);
  const show = (ev, lines) => {
    const box = ev.currentTarget.closest("[data-tip-root]");
    if (!box) return;
    const r = box.getBoundingClientRect();
    setTip({ x: ev.clientX - r.left, y: ev.clientY - r.top, lines, w: r.width });
  };
  const hide = () => setTip(null);
  const node = tip ? (
    <div
      className="pointer-events-none absolute z-10 rounded-md border border-border-default bg-bg-primary/95 px-2 py-1.5 text-[11px] text-text-primary shadow-lg whitespace-nowrap"
      style={{ left: Math.min(tip.x + 12, Math.max(0, tip.w - 190)), top: tip.y + 12 }}
    >
      {tip.lines.map((l, i) => (
        <div key={i} className={i === 0 ? "font-semibold" : "text-text-secondary"}>{l}</div>
      ))}
    </div>
  ) : null;
  return { show, hide, node };
}

// Phases for the over-based charts, from the length of the innings.
